export enum Routes {
  Projects = '/projects',
  Settings = '/settings',
  LogIn = '/login',
  Users = '/users',
  Organizations = '/organizations',
  Reports = '/reports',
}
